import { render, staticRenderFns } from "./classlist.vue?vue&type=template&id=4f2071fa&scoped=true"
import script from "./classlist.vue?vue&type=script&lang=js"
export * from "./classlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2071fa",
  null
  
)

export default component.exports